import LocalSettingsProto from "../../../../core/gd/settings/local-settings/local-settings-v3"
import {ProjectSystemType} from "../../../../core/model2/project/types"
import ProjectSession from "../../../../core/model2/project/project-session";
import {ViewType} from "../../../../core/gd/const/views/view-type"

const debug = false
// const debug = "ProjectHeaderLocalSettings"

export default class ProjectHeaderLocalSettings extends LocalSettingsProto {

    public compactSubmenuProjects: any = [] // for default setting FULL
    public fullSubmenuProjects: any = []    // for default setting COMPACT

    constructor() {
        super('project-header', {})

        // call duplicate is required because of type script
        this.normalize(this._readFromLocalStorage())
    }

    normalize(values:any) {
        this.compactSubmenuProjects = _.get(values, 'compactSubmenuProjects', [])
        this.fullSubmenuProjects    = _.get(values, 'fullSubmenuProjects', [])
    }

    flush() {
        this.compactSubmenuProjects = []
        this.fullSubmenuProjects    = []
        this.save()
    }

    _getDefaultValue(projectId:ID) {
        let defaultValue = gd.user.clientData.labs.navigation.viewProjectMenuCompact

        const project: ProjectSession | null = gd.session.projects.get(projectId)

        // check if project is PAGE project then it should be compact by default
        if (project?.isSingleView) {
            defaultValue = true
        }

        // is compact for 'No views' by default
        if (project?.isWorkspace && gd.projectViews.currentView.type === ViewType.PROJECT_NO_VIEWS) {
            defaultValue = true
        }

        // if ([ProjectSystemType.PAGE, ProjectSystemType.EMBED, ProjectSystemType.PRODUCTIVITY].includes(gd.session.projects.get(projectId)!.systemType)) {
        //     defaultValue = true
        // }

        return defaultValue
    }

    setSubmenuCompact(projectId:ID, value:boolean) {
        const defaultValue = this._getDefaultValue(projectId)

        debug && console.log(debug, 'setSubmenuCompact', defaultValue, projectId, value)

        if (defaultValue) { // if default value is COMPACT header
            value ? _.remove(this.fullSubmenuProjects, id=>id === projectId) : this.fullSubmenuProjects.push(projectId)
            debug && console.log(debug, 'setSubmenuCompact this.fullSubmenuProjects', this.fullSubmenuProjects)
        } else { // if default value is FULL header
            value ? this.compactSubmenuProjects.push(projectId) : _.remove(this.compactSubmenuProjects, id=>id === projectId)
            debug && console.log(debug, 'setSubmenuCompact this.compactSubmenuProjects', this.compactSubmenuProjects)
        }
        this.save()
    }

    isSubmenuCompact(projectId:ID):boolean {
        let res: boolean = false

        const defaultValue = this._getDefaultValue(projectId)
        if (defaultValue) { // if default value is COMPACT header
            res = !this.fullSubmenuProjects.includes(projectId) // check if project is not among manually set FULL header
        } else { // if default value is FULL header
            res = this.compactSubmenuProjects.includes(projectId) // check if project is among manually set COMPACT header
        }

        debug && console.log(debug, 'isSubmenuCompact', res, defaultValue, projectId, this)

        return res
    }

    toObject() {
        return {
            compactSubmenuProjects  : this.compactSubmenuProjects,
            fullSubmenuProjects     : this.fullSubmenuProjects,
        }
    }
}

